import React, { useRef } from 'react';
import SafeIcon from '../common/SafeIcon';
import VideoCard from './VideoCard';
import { Link } from 'react-router-dom';

const VideoRow = ({ title, videos, onPlay, seeAllLink }) => {
  const rowRef = useRef(null);

  const scroll = (direction) => {
    if (rowRef.current) {
      const { scrollLeft, clientWidth } = rowRef.current;
      const scrollTo = direction === 'left' ? scrollLeft - clientWidth * 0.8 : scrollLeft + clientWidth * 0.8;
      rowRef.current.scrollTo({ left: scrollTo, behavior: 'smooth' });
    }
  };

  if (!videos || videos.length === 0) return null;

  return (
    <div className="mb-10 md:mb-14 relative group z-10 w-full">
      <div className="flex justify-between items-end px-4 md:px-12 mb-3 md:mb-4">
        <h3 className="text-[18px] md:text-[22px] font-bold text-white tracking-wide flex items-center">
          {title}
          <SafeIcon name="ChevronRight" className="w-5 h-5 ml-1 text-rocket opacity-0 group-hover:opacity-100 transition-opacity duration-300 transform -translate-x-2 group-hover:translate-x-0" />
        </h3>
        {seeAllLink && (
          <Link to={seeAllLink} className="text-sm font-semibold text-gray-400 hover:text-white transition-colors opacity-0 group-hover:opacity-100">
            Explore All
          </Link>
        )}
      </div>

      <div className="relative">
        {/* Enhanced Left Slider Arrow (Netflix Style) */}
        <button 
          onClick={() => scroll('left')}
          className="hidden md:flex absolute left-0 top-0 bottom-8 w-14 z-20 items-center justify-center transition-all duration-300 opacity-0 group-hover:opacity-100 bg-gradient-to-r from-[#0a0a0a] via-[#0a0a0a]/80 to-transparent hover:w-16"
        >
          <SafeIcon name="ChevronLeft" className="w-10 h-10 text-white drop-shadow-2xl transform hover:scale-125 transition-transform" />
        </button>

        <div 
          ref={rowRef} 
          className="flex space-x-3 md:space-x-4 overflow-x-auto hide-scrollbar px-4 md:px-12 pb-8 pt-2 scroll-smooth snap-x snap-mandatory"
        >
          {videos.map(video => (
            // The wrapper controls the exact width, allowing VideoCard to perfectly fill the space without breaking
            <div key={video.id} className="snap-start shrink-0 w-[260px] md:w-[320px]">
              <VideoCard video={video} onPlay={onPlay} />
            </div>
          ))}
        </div>

        {/* Enhanced Right Slider Arrow (Netflix Style) */}
        <button 
          onClick={() => scroll('right')}
          className="hidden md:flex absolute right-0 top-0 bottom-8 w-14 z-20 items-center justify-center transition-all duration-300 opacity-0 group-hover:opacity-100 bg-gradient-to-l from-[#0a0a0a] via-[#0a0a0a]/80 to-transparent hover:w-16"
        >
          <SafeIcon name="ChevronRight" className="w-10 h-10 text-white drop-shadow-2xl transform hover:scale-125 transition-transform" />
        </button>
      </div>
    </div>
  );
};

export default VideoRow;